import React, { Component } from 'react';
import axios from "axios";
import Api from "../../customlib/Api";
import moment from "moment";
// import ExportLeadsReport from './ExportLeadsReport';
import Global from "../../customlib/Global"


import { makeStyles } from '@mui/styles';
import {Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Collapse, IconButton, Box, Typography, CircularProgress, Tooltip, Container, InputLabel, Select, FormControl, MenuItem, Dialog, DialogTitle, DialogContent, Grid2, Grid, DialogActions, Button, LinearProgress, Chip, TextField} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Campaign, Edit, Message, QuestionAnswer, Search } from '@mui/icons-material';
import DateRangePicker from '../../customlib/DateRangePicker';
import MessageList from '../MessageList';
import DataTable from 'react-data-table-component';

class TeleDataPendingDashboard extends Component {
    state = { 
        contactLeads : [],
        // startDate: moment(new Date()).subtract(13, "day").format("YYYY-MM-DD"),
        // endDate: moment(new Date()).subtract(13, "day").format("YYYY-MM-DD"),
        startDate: moment(new Date()).format("YYYY-MM-DD"),
        endDate: moment(new Date()).format("YYYY-MM-DD"),
        isLoading: false,
        showDialogInput: false,
        selectedCustomer: null,
        currentConversation: null,
        columns : [
          {
              name: "Nama Sales",
              selector: row => <Tooltip title={row.assignToUserName}>{row.assignToUserName}</Tooltip>,
              sortable: true
          },
          {
              name: "Nama Customer",
              selector: row => <Tooltip title={row.fromName}>{row.fromName}</Tooltip>,
              sortable: true,
          },
          {
              name: "Tgl Leads",
              selector: row => Global.formatDateTimeToStrDateTime24(row.created_at, true),
              width: "170px",
              sortable: true,
              sortFunction: (rowA, rowB) => {
                  const a = moment(rowA.created_at).format("x");
                  const b = moment(rowB.created_at).format("x");

                  return parseInt(a) >= parseInt(b) ? 1 : -1;
              }
          },
          {
              name: "Kategori Produk",
              selector: row => <Tooltip title={row.productCategory}>{row.productCategory}</Tooltip>,
              sortable: true
          },
          {
              name: "Kota Pengiriman",
              selector: row => <Tooltip title={row.cityName}>{row.cityName}</Tooltip>,
              sortable: true
          },
          {
              name: "Chat Terakhir",
              selector: row => Global.formatDateTimeToStrDateTime24(row.lastMessageReceivedAt, true),
              width: "170px",
              sortable: true,
              sortFunction: (rowA, rowB) => {
                  const a = moment(rowA.lastMessageReceivedAt).format("x");
                  const b = moment(rowB.lastMessageReceivedAt).format("x");

                  return parseInt(a) >= parseInt(b) ? 1 : -1;
              }
          },
          {
              name: "Tgl Kirim",
              selector: row => {
                if(row.hMinValue === "H-1"){
                  return <Chip label={Global.formatDateTimeToStrDateTime24(row.deliveryDate, true)} color='warning' size='small' />
                }
                if(row.hMinValue === "H-3"){
                  return <Chip label={Global.formatDateTimeToStrDateTime24(row.deliveryDate, true)} color='secondary' size='small' />
                }
                if(row.hMinValue === "H-7"){
                  return <Chip label={Global.formatDateTimeToStrDateTime24(row.deliveryDate, true)} color='primary' size='small' />
                }
                if(row.hMinValue === "H-0"){
                  return <Chip label={Global.formatDateTimeToStrDateTime24(row.deliveryDate, true)} color='error' size='small' />
                }

                return <Chip label={Global.formatDateTimeToStrDateTime24(row.deliveryDate, true)} size='small' />;
              },
              width: "170px",
              sortable: true,
              sortFunction: (rowA, rowB) => {
                  const a = moment(rowA.deliveryDate).format("x");
                  const b = moment(rowB.deliveryDate).format("x");

                  return parseInt(a) >= parseInt(b) ? 1 : -1;
              }
          },
          // {
          //     name: "H Min",
          //     selector: row => row.hMinValue,
          //     sortable: true
          // },
          // {
          //     name: "Delta",
          //     selector: row => row.deltaInHours,
          //     sortable: true
          // },
          {
              name: "Hasil FU",
              selector: row => row.hasilFu,
              // selector: row => `${row.deltaInHours}`,
              sortable: true
          },
          {
              name: "Jumlah FU",
              selector: row => row.jumlahFu,
              // selector: row => row.deliveryDate,
              sortable: true
          },

          {
              name: "Action",
              selector: row => (
                <Box>
                  <Tooltip title="Input hasil FU">
                    <IconButton size='small' color='primary' onClick={() => this.toggleShowDialogInput(row)}>
                      <Edit sx={{width: "18px", height: "18px"}} />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Follow Up">
                    <IconButton size='small' color='primary' onClick={() => this.handleShowMessages(row.contactFormatted)}>
                      <Campaign color='error' sx={{width: "18px", height: "18px"}} />
                    </IconButton>
                  </Tooltip>
                </Box>
              ),
              width: "100px"
          }
        ],
        filterHasilFu: "ALL",
        filterTanggalType: "LEADS",//LEADS, DELIVERY,
        screenWidth: 0 
    }
    
    handleResize = () => {
      this.setState({ screenWidth: window.innerWidth }, () => {
        console.log("HANDLE_RESIZE", this.state.screenWidth);
      });
    };
  
    componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
      localStorage.setItem("unmounted", "yes");
    }

    isMobile = () => {
      // return this.state.screenWidth < 768;
      // return this.state.screenWidth < 780;
      return false
    }

    componentDidMount() {
      this.getContactLeads();
      window.addEventListener('resize', this.handleResize);
    }

    toggleShowDialogInput = (selected) => {
      this.setState({showDialogInput: !this.state.showDialogInput, selectedCustomer: {...selected}});
    }

    getContactLeads = () => {
      console.log("STARTDATE : ",this.state.startDate);
      var userData = Global.get();
      console.log("USERDATA : ", userData, userData.admin, Global.isTeleAdmin(), Global.isAdminTeleUser(), userData.user.id);
      console.log("USERDATA", userData);

      var params = {
        startDate: this.state.startDate,
        endDate: this.state.endDate,
        reportMode: "tele-leads-report",
        appProfileId: Global.getAppProfile()._id,
        filterLabel: Global.labelPending(),
        filterTanggalType: this.state.filterTanggalType,
        includeJumlahFu: true
      };

      if(this.state.filterHasilFu !== "ALL"){
        params.filterHasilFu = this.state.filterHasilFu;
      }
      

      console.log("PARAMS", params);

      this.setState({
            contactLeads: [],
            additionalData: null,
            isLoading: true
          }, () => {});

      axios
        .post(Api.teleChatByCustomer(), params, Api.getRequestHeader())
        .then((response) => {
          console.log("CONTACTLEADS : ", response.data);
          console.log("USERDATA : ", "wkwkwk");
          
          var tmpContactLeads = response.data.data;
          let totalLeads = 0;
          var additionalData = response.data.additional_data;

          if(additionalData && additionalData.isLeader){
            tmpContactLeads = tmpContactLeads.filter(element => additionalData.members.includes(element.salesId));
          }else if(userData.admin === false && Global.isTeleAdmin() === false && Global.isAdminTeleUser() === false){
            console.log("LOG___", userData);
            tmpContactLeads = tmpContactLeads.filter(element => element.salesId === userData.user.id);
          }

          var totalAvgResponseTime = 0;
          var leads = [];

          let now = moment().tz("asia/jakarta");
          tmpContactLeads.forEach(lead => {
            lead.leads.forEach(contact => {
              const newData = Global.generateItemConversation(contact);
              contact.contactFormatted = newData;   
            //   if(contact.label === Global.labelPending()){   
            let deltaInHours = -1;
            if(contact.deliveryDate){
              let deliveryDate = moment(contact.deliveryDate).tz("asia/jakarta");

              deltaInHours = moment.duration(deliveryDate.diff(now)).asHours();

              contact.hMinValue = "";
              if(deltaInHours > 0 && deltaInHours <= 48){//H-1
                contact.hMinValue = "H-1";
              }else if(deltaInHours > 0 && deltaInHours <= 96){//H-3
                contact.hMinValue = "H-3";
              }else if(deltaInHours > 0 && deltaInHours <= 192){//H-7
                contact.hMinValue = "H-7";
              }else if(deltaInHours <= 0){
                contact.hMinValue = "H-0";
              }

              contact.deltaInHours = deliveryDate.diff(now, "hours");
              contact.diff = deliveryDate.diff(now, "hours");
              contact.now = now;
            }
                
            // if(contact.hMinValue !== "H-0"){
              leads.push(contact);
            // }
            //   }
            });
            // leads.push(leads);
            
          });

          var avgAll = totalAvgResponseTime/tmpContactLeads.length;

          this.setState({
            // contactLeads: [],
            additionalData: response.data.additional_data.length > 0 ? response.data.additional_data[0] : null,
            isLoading: false,
            avgAll: avgAll,
            contactLeads: leads, 
            totalLeads: totalLeads, 
            contactLeads24Hours: []
          }, () => {
            console.log("CEKDATA", this.state.contactLeads);
            // this.getLoginLogs();
          });
        })
        .catch((error) => {
          console.error("There was an error!", error);
        });
    };

    getWaMessages = (contactData) => {
      console.log("CONTACTDATA : ", contactData);
      if(contactData.fromNumber === ""){
        return;
      }
  
      this.setState({isLoading: true}, ()=>{
        const params = {
          from: contactData.fromNumber,
        };
        console.log("PARAMSWAMESSAGE", params);
    
        axios
          .post(Api.messagesList(), params, Api.getRequestHeader())
          .then((response) => {
            console.log("YOUR_MESSAGES",response.data);
            
            const responseData = response.data;
              
            const clonedMyCust = [...this.state.listMycustomer];
            let myCust = clonedMyCust.filter((cust) => cust.from===contactData.fromNumber);

            if(myCust.length > 0){
                myCust[0].messages = responseData.data;
            }

            this.setState({listMycustomer: clonedMyCust});
            
          })
          .catch((error) => {
            this.setState({ errorMessage: error.message, isLoading: false });
            console.error("There was an error!", error);
          });
      });
  
      
    };

    handleSaveHasilFu = (leadId, hasilFu, noteFu) => {
  
      this.setState({isLoading: false}, ()=>{
        const params = {
          dataPendingId: leadId,
          hasilFu: hasilFu,
          noteFu: noteFu
        };
        console.log("PARAMSWAMESSAGE", params);
    
        axios
          .post(Api.saveHasilFuDataPendingTele(), params, Api.getRequestHeader())
          .then((response) => {
            console.log("YOUR_MESSAGES",response.data);
            
            let responseData = response.data;
            if(responseData.success){
              let leads = [...this.state.contactLeads];
              let findLead = leads.find(item => item._id === leadId);
              if(findLead){
                findLead.hasilFu = hasilFu;
                this.setState({contactLeads: leads}, () => {
                  this.toggleShowDialogInput(null);
                });
              }

              
            }
            
          })
          .catch((error) => {
            this.setState({ errorMessage: error.message, isLoading: false });
            console.error("There was an error!", error);
          });
      });
  
      
    };

    handleShowMessages = (conversation) => {
      this.setState({currentConversation: conversation});
      this.scrollToElement();
    }

    handleStartDateChange = (event) => {
        var formatStartDate = event.target.value.replace("/", "-");
        console.log(formatStartDate);
        this.setState({ startDate:  formatStartDate}, this.getContactLeads);
        // this.state.startDate = formatStartDate;
        // this.getContactLeads();
        // console.log(this.state.email);
    };

    handleEndDateChange = (event) => {
        var formatStartDate = event.target.value.replace("/", "-");
        console.log(formatStartDate);
        this.setState({ endDate:  formatStartDate}, this.getContactLeads);
        // this.getContactLeads();
        // console.log(this.state.email);
    };

    handleDateChanged = (rangeDate) => {

      let startDate =  moment(rangeDate[0]).format("YYYY-MM-DD");
      let endDate =  moment(rangeDate[1]).format("YYYY-MM-DD");

      console.log("START : ", startDate, ", END : ", endDate);

      this.setState({ startDate: startDate, endDate:  endDate}, this.getContactLeads);
    }

    columns = [
        { id: 'salesName', label: 'Sales', minWidth: 170 },
        { id: 'avgResponse', label: 'Avg Response', minWidth: 100, align: "right" },
        { id: 'leadsCountTotal', label: 'Jumlah Customer', minWidth: 100, align: "right" },
        { id: 'kurangSemenit', label: '< 1 Menit', minWidth: 100, align: "right" },
        { id: 'lebih semenit', label: '> 1 Menit', minWidth: 100, align: "right" }
        // { id: 'leadsCountLavender', label: 'Fu Lavender', minWidth: 100 },
        // { id: 'leadsCountHsm', label: 'Fu HSM', minWidth: 100 }
    ];

    revElement = React.createRef();

    scrollToElement = () => {
      this.revElement.current?.scrollIntoView()
    }

    handleUpdateSelectedhasilFu = (event) => {
      console.log("SELECTED", event.target.value);
      let selected = this.state.selectedCustomer;
      selected.hasilFu = event.target.value;
      this.setState({selectedCustomer: selected});
    }

    handleUpdateNoteFu = (event) => {
      console.log("SELECTED", event.target.value);
      let selected = this.state.selectedCustomer;
      selected.noteFu = event.target.value;
      this.setState({selectedCustomer: selected});
    }

    handleFilterHasilFuChange = (event) => {
      this.setState({filterHasilFu: event.target.value}, () => {
        this.getContactLeads();
      });
    }

    handleFilterTanggalTypeChange = (event) => {
      this.setState({filterTanggalType: event.target.value}, () => {
        this.getContactLeads();
      });
    }

    options = {
      filterType: 'checkbox',
    };

    render() { 
        return ( 
          <div style={{padding:0}}>
                <Dialog maxWidth="sm" fullWidth onClose={this.toggleShowDialogInput} open={this.state.showDialogInput}>
                  <DialogTitle>Input Hasil FU</DialogTitle>
                  <DialogContent>
                    <Grid container spacing={1}>
                      <Grid item xs={2}>Customer</Grid> 
                      <Grid item xs={10}>: {this.state.selectedCustomer?.fromName}</Grid> 
                    </Grid>
                    <FormControl fullWidth size='small' sx={{mt: "10px"}}>
                      <InputLabel id="demo-simple-select-label">Hasil Fu</InputLabel>
                      <Select
                          labelId={this.state.selectedCustomer?._id}
                          id={this.state.selectedCustomer?._id}
                          value={this.state.selectedCustomer?.hasilFu}
                          label="Hasil Fu"
                          onChange={this.handleUpdateSelectedhasilFu}
                          size='small'
                          // sx={{fontSize: "12px"}}
                      >
                          <MenuItem value={"RESPON"}>Respon</MenuItem>
                          <MenuItem value={"NO RESPON"}>No Respon</MenuItem>
                          <MenuItem value={"CLOSING"}>Closing</MenuItem>
                      </Select>
                  </FormControl>
                  <FormControl fullWidth size='small' sx={{mt: "10px"}}>
                      {/* <InputLabel id="txt-note">Catatan</InputLabel> */}
                      <TextField
                        id="txt-note"
                        label="Catatan"
                        multiline
                        maxRows={4}
                        onChange={this.handleUpdateNoteFu}
                        value={this.state.selectedCustomer?.noteFu}
                      />
                  </FormControl>
                  </DialogContent>
                  <DialogActions sx={{paddingRight: "23px"}}>
                    <Button color='primary' variant='contained' size='small' onClick={() => this.handleSaveHasilFu(this.state.selectedCustomer?._id, this.state.selectedCustomer?.hasilFu, this.state.selectedCustomer?.noteFu)}>Simpan</Button>
                    <Button color='error' variant='contained' size='small' onClick={() => this.toggleShowDialogInput(null)}>Batal</Button>
                  </DialogActions>
                </Dialog>
                <Dialog maxWidth="xl" fullWidth onClose={() => this.handleShowMessages(null)} open={this.state.currentConversation === "wkwkwk"}>
                  <DialogTitle>Chat Follow Up</DialogTitle>
                  <DialogContent>
                    <Paper className='root'>
                      <MessageList
                          onUpdateReadCounter = {()=>{}}
                          onNewIncomingMessage={()=>{}}
                          onUpdateConversations={()=>{}}
                          onUpdateCsHelpState={()=>{}}
                          currentConversation={this.state.currentConversation ?? {}}
                          onUpdateContactLabelState={()=>{}}
                          onClearCurrentConversation = {()=>{}}
                          onUpdateSlow={()=>{}}
                          onUpdateJustRead={()=>{}}
                          onUpdateUnfinishedChat={()=>{}}
                          onResetUnreadCounter={()=>{}}
                          conversationList={[]}
                          logoutHandler={()=>{}}
                          onSaveCustomerName={()=>{}}
                          style={{maxHeight: "50vh", overflowY: "none"}}
                          // isMobile={this.isMobile}
                          isMobile={this.isMobile}
                      />
                  </Paper>
                  </DialogContent>
                  <DialogActions sx={{paddingRight: "23px"}}>
                  </DialogActions>
                </Dialog>
                <div>
                  <Paper elevation={3} sx={{padding: "10px", mb: "10px"}}>
                    <Box>
                      <Box>Filter</Box>
                      <Box sx={{mt: "10px"}}>
                        <div className="row">
                          <div className="col-2">
                            <FormControl fullWidth size='small'>
                                <InputLabel id="demo-simple-select-label">Hasil Fu</InputLabel>
                                <Select
                                    labelId={"filter-hasil-fu"}
                                    id={"filter-hasil-fu"}
                                    value={this.state.filterHasilFu}
                                    label="Hasil Fu"
                                    onChange={this.handleFilterHasilFuChange}
                                    size='small'
                                >
                                    <MenuItem value={"ALL"}>Semua</MenuItem>
                                    <MenuItem value={"RESPON"}>Respon</MenuItem>
                                    <MenuItem value={"NO RESPON"}>No Respon</MenuItem>
                                    <MenuItem value={"CLOSING"}>Closing</MenuItem>
                                </Select>
                            </FormControl>
                          </div>
                          <div className="col-2">
                            <FormControl fullWidth size='small'>
                              <InputLabel id="label-filter-tanggal-type">Mode Tanggal</InputLabel>
                              <Select
                                  labelId={"filter-tanggal-type"}
                                  id={"filter-tanggal-type"}
                                  value={this.state.filterTanggalType}
                                  label="Mode Tanggal"
                                  onChange={this.handleFilterTanggalTypeChange}
                                  size='small'
                              >
                                  <MenuItem value={"LEADS"}>Tanggal Leads</MenuItem>
                                  <MenuItem value={"DELIVERY"}>Tanggal Kirim</MenuItem>
                              </Select>
                            </FormControl>
                          </div>
                          <div className="col-2">
                            <DateRangePicker onDateChanged={this.handleDateChanged} />
                          </div>
                          <div className="col-1">
                            <Button sx={{mt: "2px"}} variant='contained' color='primary' disabled={this.state.isLoading === true} onClick={this.getContactLeads}>
                              <Search />
                            </Button>
                            <section ref={this.revElement} id="ref-element"></section>
                          </div>
                        </div>
                        
                      </Box>
                    </Box>
                  </Paper>
                  <div className="row">
                    <div className={this.state.currentConversation !== null ? "col-4" : "col-12"}>
                      
                      <Paper elevation={3} sx={{overflowX: 'scroll', maxWidth: "100%"}}>
                        {
                          this.state.isLoading && <LinearProgress />
                        }
                        <Box sx={{mt: "10px", ml: "20px"}}>

                          <h5>{`Leads Data pending Tele (${this.state.contactLeads.length} Leads)`}</h5>

                          <Tooltip title="Waktu kirim 1 hari lagi">
                            <Chip sx={{cursor: "pointer"}} label={"H-1"} color='warning' size='small' />
                          </Tooltip>&nbsp;
                          <Tooltip title="Waktu kirim 3 hari lagi">
                            <Chip sx={{cursor: "pointer"}} label={"H-3"} color='secondary' size='small' />
                          </Tooltip>&nbsp;
                          <Tooltip title="Waktu kirim 7 hari lagi">
                            <Chip sx={{cursor: "pointer"}} label={"H-7"} color='primary' size='small' />
                          </Tooltip>&nbsp;
                          <Tooltip title="Waktu pengiriman sudah terlewat">
                            <Chip sx={{cursor: "pointer"}} label={"Expired"} color='error' size='small' />
                          </Tooltip>
                          
                        </Box>
                        <DataTable 
                          title="" 
                          data={this.state.contactLeads} 
                          columns={this.state.columns} 
                          options={this.options} 
                          // selectableRows
                          pagination
                          progressPending={this.state.isLoading}
                          // progressComponent={<div>Loading</div>}
                        />
                      </Paper>
                        
                      {/* <Paper className="root">
                            <TableContainer>
                                <Table aria-label="sticky table" size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Nama Sales</TableCell>
                                        <TableCell>Nama Customer</TableCell>
                                        <TableCell>Tgl Leads</TableCell>
                                        <TableCell>Kategori Produk</TableCell>
                                        <TableCell>Kota Pengiriman</TableCell>
                                        <TableCell>Chat Terakhir</TableCell>
                                        <TableCell>Tanggal Kirim</TableCell>
                                        <TableCell>Hasil FU</TableCell>
                                        <TableCell>Jumlah FU</TableCell>
                                        <TableCell>Action</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        this.state.contactLeads.map(item => {
                                            // leadGroup.leads.map(item => {
                                                return (
                                                    <TableRow sx={{fontSize: "10px"}}>
                                                        <TableCell sx={{fontSize: "12px"}}>
                                                            {item.assignToUserName}
                                                        </TableCell>
                                                        <TableCell sx={{fontSize: "12px"}}>
                                                            {item.fromName}
                                                        </TableCell>
                                                        <TableCell sx={{fontSize: "12px"}}>
                                                            {Global.formatDateTimeToStrDateTime24(item.created_at)}
                                                        </TableCell>
                                                        <TableCell sx={{fontSize: "12px"}}>
                                                            {item.productCategory}
                                                        </TableCell>
                                                        <TableCell sx={{fontSize: "12px"}}>
                                                            {item.cityName}
                                                        </TableCell>
                                                        <TableCell sx={{fontSize: "12px"}}>
                                                            {Global.formatDateTimeToStrDateTime24(item.lastMessageReceivedAt)}
                                                        </TableCell>
                                                        <TableCell sx={{fontSize: "12px"}}>
                                                            {Global.formatDateTimeToStrDateTime24(item.deliveryDate)}
                                                        </TableCell>
                                                        <TableCell sx={{fontSize: "12px"}}>
                                                          {item.hasilFu}
                                                          {<FormControl fullWidth size='small'>
                                                              <InputLabel id="demo-simple-select-label">Hasil Fu</InputLabel>
                                                              <Select
                                                                  labelId={item._id}
                                                                  id={item._id}
                                                                  value={"RESPON"}
                                                                  // label="Hasil Fu"
                                                                  onChange={()=>{}}
                                                                  size='small'
                                                                  sx={{fontSize: "12px"}}
                                                              >
                                                                  <MenuItem sx={{fontSize: "12px"}} value={"RESPON"}>Respon</MenuItem>
                                                                  <MenuItem sx={{fontSize: "12px"}} value={"NO RESPON"}>No Respon</MenuItem>
                                                                  <MenuItem sx={{fontSize: "12px"}} value={"CLOSING"}>Closing</MenuItem>
                                                              </Select>
                                                          </FormControl>
                                                        </TableCell>
                                                        <TableCell sx={{fontSize: "12px"}}>
                                                            {item.jumlahFu}
                                                        </TableCell>
                                                        <TableCell sx={{fontSize: "12px", textAlign: "center"}}>
                                                          <Tooltip title="Input hasil FU">
                                                            <IconButton size='small' color='primary' onClick={() => this.toggleShowDialogInput(item)}>
                                                              <Edit sx={{width: "18px", height: "18px"}} />
                                                            </IconButton>
                                                          </Tooltip>
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            // })     
                                        })
                                    }
                                </TableBody>

                                </Table>
                          </TableContainer>
                      </Paper> */}
                    </div>
                    <div className="col-8" style={{maxHeight: "50vh", overflowY: "none"}}>
                      {
                        this.state.currentConversation !== null ? (
                            <div className='text-right'>
                              <div className="btn btn-block btn-danger" onClick={() => {this.handleShowMessages(null)}}>Close Chat</div>
                            </div>
                        ) : (<></>)
                      }
                      {
                        this.state.currentConversation !== null ? (
                            <Paper className='root'>
                                <MessageList
                                    onUpdateReadCounter = {()=>{}}
                                    onNewIncomingMessage={()=>{}}
                                    onUpdateConversations={()=>{}}
                                    onUpdateCsHelpState={()=>{}}
                                    currentConversation={this.state.currentConversation}
                                    onUpdateContactLabelState={()=>{}}
                                    onClearCurrentConversation = {()=>{}}
                                    onUpdateSlow={()=>{}}
                                    onUpdateJustRead={()=>{}}
                                    onUpdateUnfinishedChat={()=>{}}
                                    onResetUnreadCounter={()=>{}}
                                    conversationList={[]}
                                    logoutHandler={()=>{}}
                                    onSaveCustomerName={()=>{}}
                                    style={{maxHeight: "50vh", overflowY: "none"}}
                                    isMobile={this.isMobile}
                                />
                            </Paper>
                            
                        ) : (<></>)
                      }
                    </div>
                  </div>
                </div>
              </div>
         );
    }
}
 
export default TeleDataPendingDashboard;

const useRowStyles = makeStyles({
    root: {
      '& > *': {
        borderBottom: 'unset',
      },
    },
});

function Row(props) {
    const { row } = props;
    const [open, setOpen] = React.useState(false);
    const classes = useRowStyles();
  
    return (
      <React.Fragment>
        <TableRow className={classes.root}>
          <TableCell>
            <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
          <TableCell component="th" scope="row">{row.salesName}</TableCell>
          <TableCell align="right">{Global.formatTime(row.avgResponseTime)}</TableCell>
          <TableCell align="right">{row.fromLavender.length + row.fromHsm.length}</TableCell>
          <TableCell align="right">{row.under1Minute}</TableCell>
          <TableCell align="right">{row.upper1Minute}</TableCell>
          {/* <TableCell align="left">{row.fromLavender.length} FU</TableCell>
          <TableCell align="left">{row.fromHsm.length} FU</TableCell> */}
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box margin={1}>
                <div className="container border border-primary rounded">
                  <Typography variant="h6" gutterBottom component="div">
                    Customer yang Chat Ke Tele
                  </Typography>

                  <Table size="small" aria-label="purchases">
                    <TableHead>
                      <TableRow>
                        <TableCell>Nama</TableCell>
                        {
                            // Global.get().admin === true ? <TableCell>Nomor WhatsApp</TableCell> : <></>
                        }
                        <TableCell>Nomor WhatsApp</TableCell>
                        <TableCell>Label</TableCell>
                        <TableCell>Tanggal Chat Masuk</TableCell>
                        <TableCell>Response</TableCell>
                        <TableCell>Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {row.leads.map((historyRow) => (
                        <TableRow key={historyRow.id}>
                          <TableCell component="th" scope="row">
                            {historyRow.fromName}
                          </TableCell>
                          {
                              // Global.get().admin === true ? <TableCell>{historyRow.from}</TableCell> : <></>
                          }
                          <TableCell>{Global.maskPhoneNumber(historyRow.from)}</TableCell>
                          <TableCell><div className={Global.getLabelClasses(historyRow.label)}>{historyRow.label}</div></TableCell>
                          <TableCell align="left">{Global.formatDateTimeToStrDateTime24(historyRow.created_at)}</TableCell>
                          <TableCell>{Global.formatTime(historyRow.avgResponseTime)}</TableCell>
                          {/* <TableCell align="left">
                            {Global.formatDateTimeToStrDateTime24(historyRow.lastMessageReceivedAt)}
                          </TableCell> */}
                        <TableCell>
                          <Tooltip title="Lihat Chat">
                              <QuestionAnswer style={{cursor: "pointer"}} className="text-danger" onClick={() => {props.handleShowMessages(historyRow.contactFormatted)}}  />
                          </Tooltip>
                        </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </div>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }